<template>
  <div id="grid">
    <div
      v-for="poster in posters"
      :key="poster.key"
      :value="poster.key"
      class="card"
    >
      <CardHorizontal :poster="poster" />
    </div>
  </div>
</template>

<script>
import CardHorizontal from "./CardHorizontal";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Grid",
  components: { CardHorizontal },
  data() {
    return {};
  },
  computed: mapGetters(["posters"]),
  created() {
    this.bindPosters();
  },
  methods: {
    ...mapActions(["bindPosters", "nextPosters", "previousPosters"]),
    paginateNext() {
      this.nextPosters();
    },
    paginatePrevious() {
      this.previousPosters();
    },
  },
};
</script>

<style lang="scss" scoped>
#grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(260px, 1fr));
  grid-gap: 2.5rem;
  width: 80%;
  margin: auto;

  .card {
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
